/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  ColumnButton,
  DivBackgroundOpacity,
  DivToolTip,
} from "@utils/extra-style";
import { ColumnText, ColumnTextSpan, ColumnTextWrapper } from "../../PurchaseOrderList.styled";

import "../../PurchaseOrderList.scss";

const GeneralInfo = (props) => {
  const { t, data, column, companyData } = props;
  
  const colorArray = { 0: "#ED7D1B", 1: "#32A72C", 2: "#949494", 3: "#949494" };
  const backgroundColor = {
    0: "rgba(237, 125, 27, 0.15)",
    1: "rgba(50, 167, 44, 0.15)",
    2: "rgba(148, 148, 148, 0.15)",
    3: "rgba(148, 148, 148, 0.15)"
  };

  const statusText = {
    0: "PURCHASE_ORDER_STATUS_PENDING",
    1: "PURCHASE_ORDER_STATUS_SENT",
    2: "PURCHASE_ORDER_STATUS_CANCELLED",
    3: "PURCHASE_ORDER_STATUS_DELETED",
  };

  const openSiteViewPage = (id) => {
    window.open(`/site/view/${id}/general-info`, "_blank");
  };

  return (
    <>
      <DivBackgroundOpacity opacity="1">
        {column === "reference" && (
          <ColumnText fontWeight="700" decoration="underline" color="#0A4986">
            {"#" + data.reference}
          </ColumnText>
        )}
        {column === "supplier" && (
          <Link
            className="purchaseOrder-list__link-info"
            to={`/company/view/${data.supplier.id}/general-info`}
            style={{ color: "#0A4986" }}
          >
            {data.supplier.supplierName &&
              "[" + data.supplier.supplierName + "] "}
            {data.supplier.name}
          </Link>
        )}
        {column === "center" && (
          <>
            {!companyData.isCenter && companyData.isHaulier && "-"}
            {companyData.isCenter && (
              <Link
                className="purchaseOrder-list__link-info"
                to={`/company/view/${data.supplier.id}/general-info`}
                style={{ color: "#0A4986" }}
              >
                {data.supplier.supplierName &&
                  "[" + data.supplier.supplierName + "] "}
                {data.supplier.name}
              </Link>
            )}
          </>
        )}
        {column === "sites" &&
          data?.sites?.length > 0 &&
          data?.sites?.map((site, siteIndex) => {
            return (
              <ColumnTextWrapper
                key={"company_purchase_order" + siteIndex + "=" + site?.id}
              >
                {site?.id && (
                  <>
                    <Anchor
                      rel="noreferrer"
                      className="enquiry-view-header__link"
                      url={`/site/view/${site.id}/general-info`}
                      target="_blank"
                    >
                      <ColumnTextSpan
                        decoration="underline"
                        color="#0A4986"
                        id={`company_purchase_order-tooltip-id${site.id}-${data.pId}`}
                      >
                        {"#" + site.id}
                      </ColumnTextSpan>
                    </Anchor>
                    <ColumnTextSpan>
                      {siteIndex < data?.sites.length - 1 && ","}&nbsp;
                    </ColumnTextSpan>
                    <Tooltip
                      anchorSelect={`#company_purchase_order-tooltip-id${site.id}-${data.pId}`}
                      style={DivToolTip}
                      content={site.name}
                    />
                  </>
                )}
              </ColumnTextWrapper>
            );
          })}
        {column === "orderDate" && (
          <ColumnText>{getDateFormat(data.orderDate, "YYYY-MM-DD")}</ColumnText>
        )}
        {column === "totalAmountExclTax" && (
          <ColumnText fontWeight="700">{data.totalAmountExclTax}</ColumnText>
        )}
        {column === "buyer" && (
          <ColumnText>
            {data.buyer.firstName + " " + data.buyer.lastName}
          </ColumnText>
        )}
        {column === "status" && (
          <ColumnButton
            border={backgroundColor[data.status]}
            background={backgroundColor[data.status]}
            color={colorArray[data.status]}
            marginRight="10px"
            borderRadius="20px"
          >
            {t(statusText[data.status])}
          </ColumnButton>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
  companyData: PropTypes.object,
};

GeneralInfo.defaultProps = {
  page: null,
  companyData: null,
};

export default withTranslation()(GeneralInfo);
